import React from 'react';
import PropTypes from 'prop-types';

const InputFile = ({ name, label, error, apiErrors, ...rest }) => {
	return (
		<div className='form-group'>
			<label htmlFor={name}>{label}</label>
			<input type='file' className='form-control' name={name} id={name} onChange={rest.onChange} />
			{error && <div className='invalid-feedback d-block'>{error.message}</div>}
			<div className='invalid-feedback d-block'>
				{apiErrors?.[name]?.map((apiError, index) => {
					return <p key={index}>{apiError}</p>;
				})}
			</div>
		</div>
	);
};

InputFile.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	error: PropTypes.object
};

export default InputFile;
